var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStar3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 61,
    viewBox: "0 0 59 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8999 26.458H50.3999V34.381H58.8999V26.458Z",
    fill: "#F7D33E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8999 34.3813H33.3999V43.1276H41.8999V34.3813Z",
    fill: "#F7D33E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8999 17.7119H33.3999V26.4581H41.8999V17.7119Z",
    fill: "#F7D33E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 51.9766H24.8V60.7228H33.3V51.9766Z",
    fill: "#F7D33E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3 0.116699H24.8V8.86291H33.3V0.116699Z",
    fill: "#F7D33E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8001 34.3813H17.1001V43.1276H24.8001V34.3813Z",
    fill: "#F7D33E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8001 17.7119H17.1001V26.4581H24.8001V17.7119Z",
    fill: "#F7D33E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9001 26.4581H33.4001V17.7119V8.86279H24.8001V17.7119V26.4581H17.1001H8.6001V34.3811H17.1001H24.8001V43.1273V51.9764H33.4001V43.1273V34.3811H41.9001H50.4001V26.4581H41.9001Z",
    fill: "#FFE594"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 26.458H0V34.381H8.5V26.458Z",
    fill: "#F7D33E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar3);
export default __webpack_public_path__ + "static/media/icon-star-3.34011a538b78afbfa3d8203387623a2d.svg";
export { ForwardRef as ReactComponent };